import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a07e4dc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "conversation-li messenger__selection--hover",
    role: "button",
    tabindex: "0"
};
const _hoisted_2 = { class: "conversation-li__left" };
const _hoisted_3 = { class: "conversation-li__badge-wrapper" };
const _hoisted_4 = { class: "conversation-li__middle" };
const _hoisted_5 = { class: "conversation-li__body" };
const _hoisted_6 = { class: "conversation-li__header" };
const _hoisted_7 = { key: 0 };
const _hoisted_8 = { class: "conversation-li__right" };
const _hoisted_9 = { class: "conversation-li__left" };
const _hoisted_10 = /*#__PURE__*/ _createStaticVNode("<div class=\"conversation-li__middle\" data-v-5a07e4dc><div class=\"conversation-li__body\" data-v-5a07e4dc><div class=\"grasp-skeleton-box\" style=\"width:88%;margin-bottom:10px;\" data-v-5a07e4dc></div></div><div class=\"conversation-li__header\" data-v-5a07e4dc><div class=\"grasp-skeleton-box\" style=\"width:50%;\" data-v-5a07e4dc></div><span data-v-5a07e4dc></span></div></div><div class=\"conversation-li__right\" data-v-5a07e4dc></div>", 2);
import { t } from "@/utils/lang.util";
import { humanizeDateByTS } from '@/utils/index';
import { ArrowRight } from 'lucide-vue-next';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConversationListItem',
    props: {
        conversation: {
            type: Object,
        },
        skeleton: {
            type: Boolean,
            default: false
        }
    },
    setup(__props) {
        const props = __props;
        const unreadCount = computed(() => {
            return props.conversation.unreads;
        });
        const lastMessage = computed(() => {
            if (props.conversation.items) {
                return props.conversation.items[props.conversation.items.length - 1];
            }
            else {
                return null;
            }
        });
        const lastMessageBody = computed(() => {
            if (props.conversation.agent?.isTyping) {
                return t('agents.is_typing', { agentName: props.conversation.agent.nick || props.conversation.agent.name });
            }
            else {
                const body = lastMessage.value && (lastMessage.value.body || (lastMessage.value.media && lastMessage.value.media[lastMessage.value.media.length - 1].caption));
                return body ? body : t('conversation.last_message_empty_caption');
            }
        });
        const lastMessageContainMedia = computed(() => {
            return lastMessage.value && lastMessage.value.media && lastMessage.value.media.length > 0;
        });
        return (_ctx, _cache) => {
            const _component_BaseAvatar = _resolveComponent("BaseAvatar");
            const _component_BaseBadge = _resolveComponent("BaseBadge");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!__props.skeleton)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_BaseAvatar, {
                                name: __props.conversation.agent?.nick || __props.conversation.agent?.name,
                                url: __props.conversation.agent?.avatarUrl,
                                active: __props.conversation.agent?.status === 'ONLINE'
                            }, null, 8, ["name", "url", "active"]),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_BaseBadge, { count: _unref(unreadCount) }, null, 8, ["count"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("span", null, _toDisplayString(_unref(lastMessageContainMedia) ? '[media] ' : '') + _toDisplayString(_unref(lastMessageBody)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                                (_unref(lastMessage))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(humanizeDateByTS)(_unref(lastMessage).ts || (__props.conversation['createdOn']))), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createVNode(_unref(ArrowRight), { size: "20" })
                        ])
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_BaseAvatar, { skeleton: true })
                        ]),
                        _hoisted_10
                    ], 64))
            ]));
        };
    }
});
